import { Avatar } from "@mui/material";
import * as Icon from "react-feather";
import Skeleton from "react-loading-skeleton";
import React from "react";

import DeleteConfirmModal from "../../components/deleteConfirmModal";
import endevreID from "@endevre/id-client";
import { clientID, secret } from "../../auth/auth";
import Cookies from "js-cookie";

export default function ProfileDropdown({ isMenuOpen, globalUser, ...props }) {
  const client = endevreID.createClient(clientID, secret);

  const [deleteConfirmModalText, setDeleteConfirmModalText] = React.useState(
    {}
  );
  const [deleteConfirmModalIsOpen, setDeleteConfirmModalIsOpen] =
    React.useState(false);

  function deleteConfirm(
    headingText,
    bodyText,
    warningText,
    handler,
    strictness = false
  ) {
    console.log(warningText);
    setDeleteConfirmModalText({
      heading: headingText,
      body: bodyText,
      warning: warningText,
      strict: strictness,
      handler: () => {
        handler();
        setDeleteConfirmModalIsOpen(false);
      },
    });

    setDeleteConfirmModalIsOpen(true);
  }

  return (
    <>
      {isMenuOpen ? (
        <div
          className="flex flex-col justify-between w-full max-w-xs h-auto bg-white border-2 border-gray-100 shadow-[0_8px_24px_rgba(0,0,0,0.1)] rounded-2xl z-40 ease-in-out"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col gap-4">
            <div className="flex flex-row items-center justify-start gap-4 pt-4 px-4">
              <Avatar
                sx={globalUser?.firstName ? { bgcolor: "#0b84fe" } : {}}
                style={{
                  width: "48px",
                  height: "48px",
                  fontSize: "32px",
                  fontFamily: "Inter",
                  fontWeight: 600,
                }}
              >
                {globalUser?.firstName?.substring(0, 1)}
              </Avatar>
              <div className="flex flex-col items-start justify-start">
                <h1 className="text-lg font-bold line-clamp-1">
                  {globalUser?.firstName} {globalUser?.lastName}
                </h1>
                <h2 className="text-sm font-normal">
                  {globalUser?.email ?? <Skeleton className="w-44" />}
                </h2>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center">
              <ul className="flex flex-col w-full text-left">
                <li>
                  <a
                    href="/account/wallet"
                    className="group flex items-center w-full h-full px-4 py-2 bg-transparent hover:bg-slate-100 transition-all duration-150"
                  >
                    <span className="inline-flex items-center text-neutral-500 group-hover:text-black transition-all duration-150">
                      <Icon.CreditCard
                        size={18}
                        strokeWidth={3}
                        className="mr-2 stroke-2"
                      />
                      My Wallet
                    </span>
                  </a>
                </li>
                {/* <li>
                  <a
                    href="/"
                    className="group flex items-center w-full h-full px-4 py-2 bg-transparent hover:bg-slate-100 transition-all duration-150"
                  >
                    <span className="inline-flex items-center text-neutral-500 group-hover:text-black transition-all duration-150">
                      <Icon.Users
                        size={18}
                        strokeWidth={3}
                        className="mr-2 stroke-2"
                      />
                      My Memberships
                    </span>
                  </a>
                </li> */}
                <li>
                  <a
                    href="/account/saved"
                    className="group flex items-center w-full h-full px-4 py-2 bg-transparent hover:bg-slate-100 transition-all duration-150"
                  >
                    <span className="inline-flex items-center text-neutral-500 group-hover:text-black transition-all duration-150">
                      <Icon.Bookmark
                        size={18}
                        strokeWidth={3}
                        className="mr-2 stroke-2"
                      />
                      Saved Events
                    </span>
                  </a>
                </li>
              </ul>
              <hr className="w-[calc(100%-2rem)] text-transparent border-t-[1.5px] border-neutral-200 m-4" />
              <ul className="flex flex-col w-full text-left">
                <li>
                  <button
                    className="group flex items-center w-full h-full px-4 py-2 bg-transparent hover:bg-slate-100 transition-all duration-150"
                    onClick={() => {
                      deleteConfirm(
                        "Logout?",
                        "Are you sure you want to logout? This will remove all of your account information from this device.",
                        null,
                        () => {
                          
                          // delete cookie gxU__CA
                          Cookies.remove("gxU__CA");
                          // Cookies.remove("endevre_id_usernormaltoken");

                          client.logout({
                            returnURL: "/",
                          });

                          return true;
                        }
                      );
                    }}
                  >
                    <span className="inline-flex items-center text-gray-500 group-hover:text-red-500 transition-all duration-150">
                      <Icon.LogOut
                        size={18}
                        strokeWidth={3}
                        className="mr-2 stroke-2"
                      />
                      Log Out
                    </span>
                  </button>
                </li>
              </ul>
              <hr className="w-[calc(100%-2rem)] text-transparent border-t-[1.5px] border-neutral-200 m-4" />
              {/* account button */}
              <div className="flex flex-col w-full gap-2 pb-4 px-4">
                {/* Advent passport */}
                <a
                  href="/account"
                  className="flex flex-col w-full justify-center items-center py-1.5 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors duration-200 ease-in-out"
                >
                  <h1 className="text-white font-medium">
                    {globalUser ? "My Dashboard" : "Login / Sign-up"}
                  </h1>
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <DeleteConfirmModal
        DeleteModalView={deleteConfirmModalIsOpen}
        SetDeleteModalView={setDeleteConfirmModalIsOpen}
        HeadingText={deleteConfirmModalText.heading}
        BodyText={deleteConfirmModalText.body}
        ConfirmHandler={deleteConfirmModalText.handler}
        WarningText={deleteConfirmModalText.warning}
        strictDelete={deleteConfirmModalText.strict}
      />
    </>
  );
}
